import { MdMonitor, MdSecurity } from "@onemind-services-llc/react-icons-ng/md";
import { HiOutlineGlobeAlt } from "@onemind-services-llc/react-icons-ng/hi";
import { BiTestTube } from "@onemind-services-llc/react-icons-ng/bi";

export const HEADING_CONSTANTS = {
  title: "OneMind’s Shared Compute services – How we help you?  ",
  desc: "Our Shared Compute offering supports customers who need reliable infrastructure for legacy apps, internal utilities, or lightweight services that don’t demand modern CPU performance. ",
};

export const FEATURES_CONSTANTS = {
  title: "Included Features",
  list: [
    "Intel-based shared virtualization (legacy Xeon family)",
    "vCPU, RAM, and disk quotas per VM",
    "VLAN and firewall rule support",
    "Snapshot scheduling and retention",
    "Optional static private IP addressing",
    "Suitable for workloads with consistent low CPU usage",
  ],
};

export const USE_CASES_CONSTANTS = {
  title: "Common Use Cases",
  list: [
    {
      icon: MdMonitor,
      title: "Monitoring & alerting platforms",
    },
    {
      icon: MdSecurity,
      title: "Syslog or SIEM forwarders",
    },
    {
      icon: HiOutlineGlobeAlt,
      title: "Intranet portals and backend admin tools",
    },
    {
      icon: BiTestTube,
      title: "Application test environments or pilot staging",
    },
  ],
};
